import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BuildingColorsComponent } from 'src/app/modules/configuration/buildingcolors/buildingcolors.component';
import { CreateUserDialogComponent } from 'src/app/modules/configuration/createuser/createuser.component';
import { DbprecacheComponent } from 'src/app/modules/configuration/dbprecache/dbprecache.component';
import { DataService } from '../../core/services/data.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CachingSettingsComponent } from '../region/cachingsettings/cachingsettings.component';
import { RackCacheComponent } from './rackcache/rackcache.component';
import { RedliningPresetsComponent } from './redliningpresets/redliningpresets.component';
import { SchemainfoComponent } from './schemainfo/schemainfo.component';
import { AdvancedcacheComponent } from './advancedcache/advancedcache.component';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})

export class ConfigurationComponent implements OnInit {
  showPremium : boolean;
  inProgress : boolean = false;

  constructor(
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    //DB Precache and Refresh Schema are only accessible to Super Admin
    var userId = localStorage.getItem('roleId');
    if(userId === '1'){
      this.showPremium = true;
    }
  };

  onBuildingTypeClicked(): void {
    this.dialog.open(BuildingColorsComponent, {
      data: '',
      panelClass: 'custom-dialog-container',
    });
  }

  onRedliningPresetClicked() {
    this.dialog.open(RedliningPresetsComponent, {
      data: '',
      panelClass: 'custom-dialog-container',
    });
  }

  addNewUser(): void {
    this.dialog.open(CreateUserDialogComponent, {
      data: {},
      panelClass: 'custom-dialog-container',
    });
  }

  advancedCache(): void {
    this.dialog.open(AdvancedcacheComponent, {
      data: {},
      panelClass: 'custom-dialog-container',
    });
  }

  openPreCacheInfo(): void {
    this.dialog.open(DbprecacheComponent, {
      data: {},
      panelClass: 'custom-dialog-container',
    });
  }

  chooseBuildingtypes(): void {
    this.dialog.open(RackCacheComponent, {
      data: {},
      panelClass: 'custom-dialog-container',
    });
  }

  startRefreshSchema(): void {
    this.inProgress = true;
    this.dataService.runRefreshSchema().subscribe({
      next: (data) => {
        if(data.status === 200){
          this._snackBar.open($localize `Refresh Schema successful`, '', {
            duration: 3000
          });
          this.inProgress = false;
        }
        else{
          this._snackBar.open($localize `Refresh Schema failed`, '', {
            duration: 3000
          });
          this.inProgress = false;
        }
      },
    });
  }

  setRegionCacheSettings(){
    this.dialog.open(CachingSettingsComponent, {
      panelClass: 'custom-dialog-container',
      data: '',
    });
  }

  initiateRefreshSchema() {
    this.dialog.open(SchemainfoComponent, {
      panelClass: 'custom-dialog-container',
      data: '',
    });
    // let dialogRef = this.dialog.open(updateSchema);
    // dialogRef.afterClosed().subscribe(res => {
    //   if(res !== undefined){
    //     if(res.data === 'OK'){
    //       this.startRefreshSchema();
    //     }
    //   }
    //   else{}
    // })
  }
}

@Component({
  selector: 'updateSchema',
  templateUrl: 'updateSchema.html',
})

export class updateSchema {
  constructor(
    public dialogRef: MatDialogRef<updateSchema>,
    @Inject(MAT_DIALOG_DATA)
    private _snackBar: MatSnackBar,
  ){}

  confirmRefreshSchema(): void {
    this.dialogRef.close({ data: 'OK' });
  }
}
